import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ENDPOINTS, PROMOFLOW_BASE_API_URL } from '../../api/endPoints';
import { post } from '../../api/service/apiService';
import {
  triggerWorkflowRequest,
  triggerWorkflowSuccess,
  triggerWorkflowFailure,
} from '../slices/workflowTriggerSlice';

interface WorkflowResponse {
  success: boolean;
  restaurant_id: string;
  message: string;
}

function* handleTriggerWorkflow(action: PayloadAction<{ restaurantId: string }>) {
  try {
    const { restaurantId } = action.payload;
    
    // POST request to trigger workflow with restaurant_id in both query params and payload
    const response: { data: WorkflowResponse } = yield call(post, {
      endpoint: `${ENDPOINTS.triggerWorkflow}`,
      params: { restaurant_id: restaurantId },
      body: { restaurant_id: restaurantId }
    });

    yield put(triggerWorkflowSuccess(response.data));
  } catch (error: any) {
    yield put(triggerWorkflowFailure(error.message || 'Failed to trigger workflow'));
  }
}

export default function* workflowTriggerSaga() {
  yield takeLatest(triggerWorkflowRequest.type, handleTriggerWorkflow);
}
